import React, { useState } from 'react';
import { connect } from 'react-redux';
import * as StyledCookiesDisclaimer from './cookiesDisclaimer.styles';
import {
	P, Button
} from '../base';
import { COOKIE_SETTINGS_MODAL } from '../../constants/modals';
import sleep from '../../helpers/sleep';
import { openModal } from '../../actions/modalActions';
import { setCookieConfirmation } from '../../actions/cookieActions';

const CookiesDisclaimer = ({ dispatch, cookieReducer }) => {
	const { value } = cookieReducer;
	const [fadeOut, setFadeOut] = useState(false);

	const approveCookies = async () => {
		setFadeOut(true);
		await sleep(450);
		dispatch(setCookieConfirmation('approved'));
	};

	const openSettings = () => {
		dispatch(openModal(COOKIE_SETTINGS_MODAL));
	};

	// If cookies have been accepted we render nothing
	if(value === 'approved') return null;

	return (
		<StyledCookiesDisclaimer.Wrapper fadeOut={fadeOut}>
			<P lineHeight="1.4">Þessi síða notar fótspor (e.cookies) til að muna eftir þér og bæta upplifun þína af síðunni.</P>
			<StyledCookiesDisclaimer.ButtonWrapper>
				<Button onClick={openSettings}>Stillingar</Button>
				<Button primary onClick={approveCookies}>Samþykkja</Button>
			</StyledCookiesDisclaimer.ButtonWrapper>
		</StyledCookiesDisclaimer.Wrapper>
	);
};

const mapStateToProps = ({ cookieReducer }) => ({
	cookieReducer
});

export default connect(mapStateToProps)(CookiesDisclaimer);
